import React from "react";
import { action } from "storybook/actions";
import VStack from "../../ui_atoms/VStack";
import { ScrollView } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";
import QuantityField, { QuantityFieldProps } from "../../components/QuantityField";

const StoryComponent = ({ ...fieldProps }: QuantityFieldProps) => {
    const [value, setValue] = React.useState<number | undefined>(10);

    const handleChange = (value?: number) => {
        setValue(value);
        action("onChange")(value);
    };

    return (
        <ScrollView style={{ width: "100%" }}>
            <VStack gap={0.5} style={{ padding: 10, alignSelf: "stretch", maxWidth: 500 }}>
                <QuantityField
                    value={value}
                    onChange={handleChange}
                    style={{ alignSelf: "stretch" }}
                    {...fieldProps}
                />
            </VStack>
        </ScrollView>
    );
};

const meta = {
    title: "Fields/Quantity",
    component: StoryComponent,
    argTypes: {
        disabled: {
            control: {
                type: "boolean",
            },
        },
        error: {
            control: {
                type: "text",
            },
        },
        decimalPlaces: {
            control: {
                type: "number",
            },
        },
    },
    args: {
        label: "Input something",
    },
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {
        disabled: false,
    },
};

export const Decimal: Story = {
    args: {
        disabled: false,
        decimalPlaces: 2,
    },
};

export const Negative: Story = {
    args: {
        disabled: false,
        decimalPlaces: 2,
        allowNegativeValue: true,
    },
};

export const WithError: Story = {
    args: {
        disabled: false,
        decimalPlaces: 2,
        error: "This is an error",
        allowNegativeValue: true,
    },
};

export const Disabled: Story = {
    args: {
        disabled: true,
        decimalPlaces: 2,
        allowNegativeValue: true,
    },
};
